
import { checkForDuplicateContractors } from "./duplicateChecker";

// Function to check for duplicates and log results to console
export const logDuplicateContractors = async () => {
  console.log("Checking for duplicate contractors...");
  try {
    const duplicateGroups = await checkForDuplicateContractors();
    
    if (duplicateGroups.length === 0) {
      console.log("✅ No duplicates found in the contractors table!");
      return;
    }
    
    console.log(`🔍 Found ${duplicateGroups.length} groups of potential duplicates:`);
    
    duplicateGroups.forEach((group, index) => {
      console.group(`Group ${index + 1}: ${group.key}`);
      group.contractors.forEach(contractor => {
        console.log(`ID: ${contractor.id}, Name: ${contractor.name}, Service: ${contractor.service_type}, Location: ${contractor.location}, Rating: ${contractor.rating}`);
      });
      console.groupEnd();
    });
    
    console.log("To fix duplicates, consider merging or removing redundant entries in the Supabase database.");
    
    return duplicateGroups;
  } catch (error) {
    console.error("Error checking for duplicates:", error);
    throw error;
  }
};

// Make it available globally for console access
if (typeof window !== 'undefined') {
  (window as any).checkDuplicateContractors = logDuplicateContractors;
}
